<div class="container">
  <div class="head">
    <div mat-dialog-title
         class="head-label">{{ 'MENU.MODIFIERS' | translate }}</div>
    <mat-icon mat-dialog-close class="head-exit">close</mat-icon>
  </div>
</div>
